import { render, staticRenderFns } from "./widget_add.vue?vue&type=template&id=1d9e3ff4&scoped=true&"
import script from "./widget_add.vue?vue&type=script&lang=js&"
export * from "./widget_add.vue?vue&type=script&lang=js&"
import style0 from "./widget_add.vue?vue&type=style&index=0&id=1d9e3ff4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9e3ff4",
  null
  
)

export default component.exports